var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"cursor-pointer text-primary-90 text-primary-100:hover",on:{"click":function($event){return _vm.importFile()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" Import spreadsheet")])])}
var staticRenderFns = []

export { render, staticRenderFns }